/**
 * Reconhecer — os conceitos que o fluxo, o rascunho e as etapas compartilham.
 *
 * Módulo sem React de propósito: as regras e as telas dependem dele, e ele não depende de
 * nenhuma delas.
 */
import { User } from 'types/user';

import { CoinKey } from './recognition-points';

/** Comportamentos na ordem do design. `resolutividade` é a chave de "Protagonismo". */
export const BEHAVIOR_KEYS = ['colaboracao', 'foco', 'inovacao', 'resolutividade', 'lideranca'] as const;

export type BehaviorKey = (typeof BEHAVIOR_KEYS)[number];

/** Só quem lidera pode ser reconhecido por este comportamento. */
export const LEADER_ONLY_BEHAVIOR: BehaviorKey = 'lideranca';

export function isBehaviorKey(value: unknown): value is BehaviorKey {
  return BEHAVIOR_KEYS.includes(value as BehaviorKey);
}

/** Um reconhecimento com todas as escolhas feitas: o que a revisão mostra e o envio manda. */
export type Recognition = {
  target: User;
  behavior: BehaviorKey;
  coin: CoinKey;
  points: number;
  /** HTML da mensagem, como vai para o servidor. */
  message: string;
};

export type ColleagueSearch = {
  searching: boolean;
  results: User[];
  /** A busca terminou sem ninguém. */
  noResults: boolean;
  /** A busca sem resultado foi por matrícula (F e dígitos). */
  unknownId: boolean;
};

export type RecognitionAlertContent = {
  text: string;
  /**
   * Versão formatada do aviso (negrito, cor, sublinhado), cadastrada no Studio. Só o bloqueio
   * por grupo restrito a envia; os demais avisos são texto puro.
   */
  html?: string;
  /** Aviso informativo ("Olá!"), e não um impedimento ("Ops!"). */
  isNotice?: boolean;
};
